<template>
  <div>
    <button class="btn" :class="[this.btnClass]" @click.prevent="$emit('next-clicked')">
      <i class="fas fa-2x fa-chevron-right"></i>
    </button>
    <span class="text-center mx-auto">
      <slot>Next</slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'NextButton',
  props: {
    buttonClass: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      btnClass: this.buttonClass
    }
  },
  methods: {},
  computed: {}
}
</script>

<style scoped>
button {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  border: none !important;
  box-shadow: 0 0 7px 0 gray;
  transition: transform .25s ease-out;
}

button:hover {
  transform: translateX(6px);
}

div {
  position: fixed;
  left: 74%;
  top: 47%;
}

i {
  position: relative;
  top: 3px;
  left: 3px;
  color: white;
}

span {
  width: 80px;
  line-height: 1.25em;
  font-size: 12px;
  margin-left: 10px !important;
}
</style>